module.exports = __webpack_public_path__ + "static/media/Logo_monclova2.e20e7e19.png";